<template>

    <el-table-column v-if="itemData.state == '1'" :label="itemData.label" :property="itemData.property" sortable="custom" :fixed="fixedIndex" :min-width="itemData.width && parseInt(itemData.width) > 100 ? itemData.width : '100'" >
        <template slot-scope="scope" v-if="!itemData.list">
            <div v-html="scope.row[itemData.property]"></div>
            <!-- {{/^(\-)?\d+(\.\d{1,2})?$/.test(scope.row[itemData.property].replace(/<[^>]+>/g, "")) ? Number(scope.row[itemData.property]) : scope.row[itemData.property]}} -->
        </template>

        <template v-if="itemData.list && itemData.list.length > 0">
            <table-item v-for="(item,index) in itemData.list" :key="index" :itemData="item"></table-item>
        </template>
    </el-table-column>

</template>

<script>
export default {
    name: "tableItem",
    props: {
        // 表头
        itemData: {
            type: Object,
            default: () => {}
        },

        // 固定列
        fixedIndex: {
            type:Boolean,
            default: false
        }
    },
}
</script>